import generateQuery from 'src/utils/generate-query';

import Base from '../Base';
import { LocationAutocompleteResponse, Options } from '../types';

export default class Geolocator extends Base {
  private static _instance: Geolocator;

  constructor(options: Options) {
    super(options);
  }

  public static getInstance(options: Options) {
    if (!this._instance) {
      this._instance = new this(options);
    }

    return this._instance;
  }

  autocomplete(params: {
    query: string;
    country: string;
  }): Promise<LocationAutocompleteResponse> {
    const query = generateQuery(params);
    const url = this.buildUrl(`/autocomplete${query}`);

    return this.makeRequest({
      url,
      method: this._request.Get
    });
  }

  private buildUrl(path: string) {
    return `https://${this._api_host}/api/v${this._api_version}${path}`;
  }
}
